import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Bold = createReactComponent("Bold", ["svg", defaultAttributes, [["path", {
  d: "M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6z",
  key: "y8kye"
}], ["path", {
  d: "M6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z",
  key: "e5wyww"
}]]]);
export default Bold;